



/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// GETALLPLANSWITHCREATOR
// GETALLPLANSWITHCREATOR
const GETALLPLANSWITHCREATOR= createAsyncThunk(
  "getAllPlansWithCreator/getAllPlansWithCreator",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllPlansWithCreatorSlice = createSlice({
  name: "getAllPlansWithCreatorSlice",
  initialState: {
    getAllPlansWithCreator: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllPlansWithCreator: (state) => {
        state.getAllPlansWithCreator.loading = false
        state.getAllPlansWithCreator.error = false
        state.getAllPlansWithCreator.data = []
        state.getAllPlansWithCreator.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLPLANSWITHCREATOR.fulfilled, (state, action) => {
      state.getAllPlansWithCreator = {
        ...state.getAllPlansWithCreator,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPLANSWITHCREATOR.pending, (state, action) => {
      state.getAllPlansWithCreator = {
        ...state.getAllPlansWithCreator,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLPLANSWITHCREATOR.rejected, (state, action) => {
      state.getAllPlansWithCreator = {
        ...state.getAllPlansWithCreator,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllPlansWithCreatorAction = {
    GETALLPLANSWITHCREATOR,
};

export { getAllPlansWithCreatorAction };
export default getAllPlansWithCreatorSlice.reducer;
export const {setInitialStateOfgetAllPlansWithCreator} = getAllPlansWithCreatorSlice.actions